import { alpha, useTheme, Box, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

const Heatmap = ({ onClick, active,canSee, mapsView, ...props }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (!canSee) return null
  return (
    <Tooltip
      arrow
      placement="left"
      title={t(
        `cartography.maps.controls.${
          active ? 'heatmap_on' : 'heatmap_off'
        }`,
      )}
    >
      <Box
        sx={{
          color: active ? '#464646' : theme.palette.primary.main,
          cursor: 'pointer',
          backgroundColor: 'white',
          minHeight: '40px',
          minWidth: '40px',
          maxHeight: '40px',
          maxWidth: '40px',
          borderRadius:'50%',
          border: 'solid 1px',
          borderColor: 'border.primary',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: `0 12px 16px -8px ${alpha(
            theme.palette.common.black,
            0.24,
          )}`,
          '&:hover': {
            color: theme.palette.primary.main,
          },
        }}
        onClick={onClick}
      >
        <i className={`fa-kit fa-${active ? 'solid' : 'regular'}-fire-flame-curved-location-pin`}></i>
      </Box>
    </Tooltip>
  )
}

export default Heatmap